import { IconAlertTriangle } from "@tabler/icons-react";
import React from "react";

interface ICustomPageNotificationProps {
  title: string;
  message: string;
}

const CustomPageNotification: React.FC<ICustomPageNotificationProps> = ({
  title = "Attention Required",
  message,
}) => {
  return (
    <div
      style={{
        background: "#ffe3e3",
        borderLeft: "6px solid #fa5252",
        padding: "12px 16px",
        borderRadius: 6,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <IconAlertTriangle size={24} color="orange" />
        <label style={{ fontWeight: 600 }}>{title}</label>
      </div>

      <div
        style={{
          color: "#c92a2a",
          fontSize: "11pt",
          marginTop: "5px",
          fontWeight: "bold",
        }}
      >
        {message}
      </div>
    </div>
  );
};

export default CustomPageNotification;
